// Org-wide chat history across every chatbot in the organization.
// Sidebar → Organization → History (/history). Gated by the
// conversations.view permission (route registration in App.tsx).

import { PageShell } from "@/components/page-shell";
import { HistoryView } from "@/components/history-view";

export default function TenantHistoryPage() {
  return (
    <PageShell
      title="Tenant History"
      titleTestId="text-tenant-history-title"
      subtitle="Complete chat history across all your chatbots — bot conversations and live-agent sessions."
    >
      <HistoryView listKey={["/api/history"]} showBotName />
    </PageShell>
  );
}
